import { LegalLayout, LegalSection, LegalNote } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function InterestRatePolicyPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Interest Rate Policy"
      description="Transparent. Fair. Compliant."
    >
      <LegalSection heading="Background">
        <p>
          The Reserve Bank of India ("RBI") advises that Non-Banking
          Financial Companies (NBFCs) and their Board of Directors undertake
          a comprehensive review of their internal principles and
          procedures for determining interest rates, processing fees, and
          other charges.
        </p>
        <p>
          {siteConfig.companyName} (hereinafter referred to as "Company")
          shall adopt all such guidelines prescribed by RBI from time to
          time and shall make appropriate modifications, if any necessary,
          to this Policy to conform to the standards so prescribed. In
          compliance with these regulatory requirements and the Fair
          Practices Code adopted by the Company, the Company has adopted
          this Interest Rate Policy broadly outlining the Interest Rate
          Model and the Company's approach to risk gradation in its lending
          business.
        </p>
      </LegalSection>

      <LegalSection heading="Disclosure">
        <p>
          The interest rate determination process and interest rate shall be
          disclosed on the Company's website and shared with the customer in
          a timely and transparent manner.
        </p>
      </LegalSection>

      <LegalSection heading="Interest Rate Model">
        <p>
          This policy is approved by the Board of Directors of the Company,
          and the Company has adopted the interest rate model considering
          all relevant factors such as cost of funds, margin, and risk
          premium in order to determine the rate of interest to be charged
          for loans and advances. The rate of interest and the approach for
          gradation of risk shall be disclosed to borrowers through the
          Company's website and/or other means in a timely and transparent
          manner, and updated whenever there is any change. The rate of
          interest to be charged from every individual borrower shall be
          communicated individually by way of loan documentation, followed
          by explicit written consent prior to disbursal.
        </p>
        <p>
          This policy states that the interest rate or other rates and
          costs charged to the borrower shall be based on the following
          broad parameters:
        </p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Risk profile of the borrower</li>
          <li>Credit score of the borrower</li>
          <li>Funds raising cost</li>
          <li>Cost of equity</li>
          <li>Operational expense ratio</li>
          <li>Credit loss / recovery cost</li>
          <li>Other factors that may be relevant in each case</li>
        </ul>
        <LegalNote>
          Note: Specific loan range, tenure, and maximum APR figures for{" "}
          {siteConfig.companyName} are yet to be confirmed and published
          here — placeholder figures have intentionally been left out
          pending that information.
        </LegalNote>
        <p>
          All loans are offered at fixed rates with repayment via EMIs or
          bullet payments through electronic channels only.
        </p>
      </LegalSection>

      <LegalSection heading="Fees & Charges">
        <p>
          Besides interest, the Company may require borrowers to bear
          certain financial costs for availing the loan, usually in the
          nature of processing/credit assessment fees or origination fees.
          These charges shall not be collected from any customer at the
          time of loan application — only from those customers who are
          sanctioned a loan and are willing to avail the disbursal, and the
          customer is credited with the loan amount net of any applicable
          fees. The Company shall not charge any fees from customers who
          apply but are not approved, or are approved but do not avail the
          loan.
        </p>
        <p>
          In addition, the Company may require borrowers to bear charges
          such as EMI mandate return charges, ECS/Direct Debit/ACH mandate
          registration or handling charges, fees for rescheduling of loans,
          or other costs incurred by the Company for the provision of
          related services, as per the schedule of charges communicated by
          the Company from time to time. Applicable taxes and cesses, if
          any, would be collected at applicable rates. Any revision in
          charges will be prospective. Refund/waiver requests are at the
          sole discretion of the Company.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
